import React, { useContext } from 'react';
import { ThumbUp } from '@mui/icons-material';
import { Button } from '@mui/material';

import {
    SessionContext,
    SessionContextType,
} from '../../../../contexts/session';
import {
    AnonymousUserContext,
    AnonymousUserContextType,
} from '../../../../contexts/anonUser';
import { PollRecord } from '../../../../models/Poll';

interface VoteButtonProps {
    poll: PollRecord;
    option: 1 | 2;
    disabled?: boolean | undefined;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const VoteButton = (
    props: React.PropsWithChildren<VoteButtonProps>,
): JSX.Element => {
    const { session } = useContext<SessionContextType>(SessionContext);
    const { anonUser } =
        useContext<AnonymousUserContextType>(AnonymousUserContext);
    const thumb =
        (session.votes &&
            props.poll.id in session.votes &&
            Number(session.votes[props.poll.id].optionId) === props.option) ||
        (anonUser.votes &&
            props.poll.id in anonUser.votes &&
            Number(anonUser.votes[props.poll.id].optionId) === props.option);

    return (
        <Button
            className='vote-button'
            disabled={props.disabled}
            onClick={props.onClick}
        >
            {props.poll.options[props.option - 1].text ||
                `Option ${props.option}`}
            {thumb && <ThumbUp />}
        </Button>
    );
};

export default VoteButton;
